/** @jsxImportSource @emotion/react */

import React, { FC, useEffect, useState } from 'react'
import { Button, TextareaAutosize as MuiTextareaAutosize } from '@mui/material'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import * as textAreaClasses from 'components/TextareaAutosize/styles'
import * as classes from './styles'

export type DescriptionFormProps = {
  subjectId: string
}

type Props = {
  description: string
  onSubmit: (description: string) => Promise<void>
  deps?: React.DependencyList
}

export const CategoryDescription: FC<Props> = ({ description, onSubmit, deps = [] }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [tempValue, setTempValue] = useState(description)

  useEffect(() => {
    setTempValue(description)
  }, deps)

  const handleSave = async (value: string) => {
    try {
      setIsSubmitting(true)
      await onSubmit(value)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleCancel = () => {
    setIsEditing(false)
    setTempValue(description)
  }

  const handleConfirm = async () => {
    await handleSave(tempValue)
    setIsEditing(false)
  }

  return (
    <div css={classes.wrapper}>
      <div css={classes.buttonsWrapper}>
        {!isEditing ? (
          <Button
            variant="outlined"
            color="gray"
            size="small"
            onClick={() => setIsEditing(true)}
            disabled={isSubmitting}
            css={classes.iconButton}
          >
            <EditIcon />
          </Button>
        ) : (
          <>
            <Button variant="outlined" color="red" size="small" onClick={handleCancel} css={classes.iconButton}>
              <CrossIcon />
            </Button>
            <Button variant="outlined" color="green" size="small" onClick={handleConfirm} css={classes.iconButton}>
              <CheckIcon />
            </Button>
          </>
        )}
      </div>
      <MuiTextareaAutosize
        value={tempValue}
        onChange={(e) => setTempValue(e.target.value)}
        disabled={isSubmitting}
        css={[textAreaClasses.textArea, classes.input]}
        readOnly={!isEditing}
      />
    </div>
  )
}
